import { memo, ReactNode } from "react";

import BudgeRequire from "@/components/atoms/inputForms/BudgeRequire";

interface LabelType {
  children: ReactNode;
  isRequireLabel?: boolean;
  htmlFor?: string;
  id?: string;
  disabled?: boolean;
  className?: string;
}

const LabelBase = (props: LabelType) => {
  return (
    <label
      className={[
        "block mb-2 text-sm font-bold",
        props.className,
        props.disabled ? "opacity-30" : "",
      ].join(" ")}
      htmlFor={props.htmlFor}
      id={props.id}
    >
      {props.children}
      {props.isRequireLabel && <BudgeRequire />}
    </label>
  );
};

export const Label = memo(LabelBase);
